import {
  RENAME_ITEM_REQUEST,
  RENAME_ITEM_SUCCESS,
  RENAME_ITEM_FAILURE,
} from '../../constants/action-types';

const getInitialState = () => {
  return {
    isLoading: false,
    data: {},
    error: false,
  };
};

const initialState = getInitialState();

const renameItem = (state = initialState, action) => {
  const types = {
    [RENAME_ITEM_REQUEST]: () => ({
      ...state,
      isLoading: true,
    }),
    [RENAME_ITEM_SUCCESS]: () => ({
      ...state,
      isLoading: false,
      error: false,
      data: action.response,
    }),
    [RENAME_ITEM_FAILURE]: () => ({
      ...state,
      isLoading: false,
      error: true,
      message: action.message,
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default renameItem;
